export { PreferencesComponent } from './preferences.component';
